export const CAROUSEL_WINDOW_SIZE = 3;
export const CAROUSEL_MOBILE_WINDOW_SIZE = 1;
export const CAROUSEL_PEEK_SIZE = 1;

/**
 * Below this breakpoint the carousel only fits one full item plus peeks, so
 * `CAROUSEL_MOBILE_WINDOW_SIZE` is used instead of `CAROUSEL_WINDOW_SIZE`.
 * Keep this value in sync with the `max-width: 768px` media query in
 * `cost-to-build-client-ui-carousel.scss`.
 */
export const CAROUSEL_MOBILE_BREAKPOINT_QUERY = '(max-width: 768px)';
